import GammeProduitFormController from './gamme.produit.form.controller';

export default {
    template: require('./gamme.produit.form.html'),
    controller: GammeProduitFormController
};
